<template>
  <div>
    <van-nav-bar
      title="修改密码"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      label="手机号码"
      v-model="userInfo.mobile"
      disabled
    />
    <van-field
      v-model="form.code"
      label-class="label-class"
      type="number"
      label="验 证 码"
    >
      <template #button>
        <van-button slot="button" size="small" @click="sendVerifySms" v-if="codeSended == false"
                    type="info">获取验证码
        </van-button>
        <van-button slot="button" size="small" disabled v-else type="info">{{codeSendBtntext}}
        </van-button>
      </template>
    </van-field>
    <van-field
      v-model="form.password"
      type="password"
      label="修改密码"
    />
    <van-field
      v-model="form.repassword"
      type="password"
      label="确认密码"
    />
    <div style="margin: 16px;">
      <van-button round block type="info" @click="onSubmit">
        提交
      </van-button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "agentadd",
    data() {
      return {
        show: false,
        userInfo: {},
        codeSended: false,
        codeSendBtntext: '',
        form: {}
      };
    },
    methods: {
      onClickLeft() {
        window.history.go(-1)
      },
      onSubmit() {
        if(!this.form.code){
          return  this.$toast.fail("请输入验证码")
        }
        if(!this.form.password){
          return  this.$toast.fail("请输入新的密码")
        }
        if(this.form.password != this.form.repassword) {
          return  this.$toast.fail("两次输入密码不一样")
        }
        this.fetchDataPost("/agent/editPass",this.form,res=>{
          if(res.code){
            this.$router.back()
            this.$toast.success(res.msg)
          }else{
            this.$toast.fail(res.msg)
          }
        })
      },
      sendVerifySms() {
        if (!this.userInfo.mobile) {
          this.$toast.fail("账号未绑定手机号码")
          return false
        }
        if (this.codeSended == true) return false
        this.$toast.loading("发送中")
        this.fetchData("/sms/sendVerifyOperatorCode", {mobile: this.userInfo.mobile}, (res) => {
          this.$toast.loading().clear()
          if (res.code) {
            this.codeSended = true
            let i = 60
            let intval = setInterval(() => {
              if (i <= 0) {
                clearInterval(intval)
                this.codeSended = false
                this.codeSendBtntext = "获取验证码"
              } else {
                this.codeSendBtntext = "( " + i + "s )"
                i--
              }
            }, 1000)
            this.$toast.success(res.msg)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
    },
    created: function () {
      this.fetchData('/account/info', {}, (res) => {
        this.userInfo = res.data
      })
    }
  };
</script>
<style lang="scss" scoped>
  .label-class {
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/resetpassword.vue